/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1LocationCitiesMutationRequest,
  PostApiV1LocationCitiesMutationResponse,
  PostApiV1LocationCities400,
  PostApiV1LocationCities401,
  PostApiV1LocationCities404,
  PostApiV1LocationCities409,
  PostApiV1LocationCities500,
} from "../../types/locationCityController/PostApiV1LocationCities.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1LocationCities } from "../../clients/locationCityController/postApiV1LocationCities.ts";

export const postApiV1LocationCitiesMutationKey = () =>
  [{ url: "/api/v1/location/cities" }] as const;

export type PostApiV1LocationCitiesMutationKey = ReturnType<
  typeof postApiV1LocationCitiesMutationKey
>;

export function postApiV1LocationCitiesMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PostApiV1LocationCitiesMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const mutationKey = postApiV1LocationCitiesMutationKey();
  return mutationOptions<
    PostApiV1LocationCitiesMutationResponse,
    ResponseErrorConfig<
      | PostApiV1LocationCities400
      | PostApiV1LocationCities401
      | PostApiV1LocationCities404
      | PostApiV1LocationCities409
      | PostApiV1LocationCities500
    >,
    { data?: PostApiV1LocationCitiesMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return postApiV1LocationCities(data, config);
    },
  });
}

/**
 * @description Cria uma nova cidade vinculada a um estado. O código é único globalmente e o nome é único dentro do estado. **(Requer Authorization para autenticação)**
 * @summary Criar cidade (Requer Authorization para autenticação)
 * {@link /api/v1/location/cities}
 */
export function usePostApiV1LocationCities<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1LocationCitiesMutationResponse,
      ResponseErrorConfig<
        | PostApiV1LocationCities400
        | PostApiV1LocationCities401
        | PostApiV1LocationCities404
        | PostApiV1LocationCities409
        | PostApiV1LocationCities500
      >,
      { data?: PostApiV1LocationCitiesMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PostApiV1LocationCitiesMutationRequest>> & {
      client?: Client;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postApiV1LocationCitiesMutationKey();

  const baseOptions = postApiV1LocationCitiesMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiV1LocationCitiesMutationResponse,
    ResponseErrorConfig<
      | PostApiV1LocationCities400
      | PostApiV1LocationCities401
      | PostApiV1LocationCities404
      | PostApiV1LocationCities409
      | PostApiV1LocationCities500
    >,
    { data?: PostApiV1LocationCitiesMutationRequest },
    TContext
  >;

  return useMutation<
    PostApiV1LocationCitiesMutationResponse,
    ResponseErrorConfig<
      | PostApiV1LocationCities400
      | PostApiV1LocationCities401
      | PostApiV1LocationCities404
      | PostApiV1LocationCities409
      | PostApiV1LocationCities500
    >,
    { data?: PostApiV1LocationCitiesMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1LocationCitiesMutationResponse,
    ResponseErrorConfig<
      | PostApiV1LocationCities400
      | PostApiV1LocationCities401
      | PostApiV1LocationCities404
      | PostApiV1LocationCities409
      | PostApiV1LocationCities500
    >,
    { data?: PostApiV1LocationCitiesMutationRequest },
    TContext
  >;
}
